<template>
    <div id="invoice-page">

        <div class="flex flex-wrap items-center justify-between" v-if="roleName == 'admin'">
          <vx-input-group class="mb-base mr-3">
            <vs-input v-model="mailTo" placeholder="Email" />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button type="border" @click="mailTo = ''" class="whitespace-no-wrap">Send Invoice</vs-button>
              </div>
            </template>
          </vx-input-group>
          <div class="vx-col w-full flex" id="account-manage-buttons">
            
          </div>
          <div class="flex items-center">            
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-billing-edit', params: { editId: $route.params.viewId }}" 
            :disabled="!showU">Edit <!-- crud -->
            </vs-button> 
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord" 
            :disabled="!showD">Delete <!-- crud -->
            </vs-button>            
          </div>
          <div class="flex items-center">            
            <!-- <vs-button class="mb-base mr-3" type="border" icon-pack="feather" icon="icon icon-download">Download</vs-button> -->
            <!-- <vs-button class="mb-base mr-3" type="border" icon-pack="feather" icon="icon icon-check-square">Accept</vs-button> -->
            <vs-button icon-pack="feather" color="success" icon="icon-dollar-sign" 
            v-if="roleName == 'admin'"
            :class="{'cursor-not-allowed': parseInt(view_data.status) == 1, 'mb-base mr-3': true}"
            :disabled="parseInt(view_data.status) == 1"
            :to="{name: 'caliber-financial-new', params: { billId: $route.params.viewId }}"
            >Pay Now</vs-button>
            <vs-button class="mb-base mr-3" icon-pack="feather" icon="icon icon-file" @click="printInvoice">Print</vs-button>
          </div>          
        </div>

        <div class="flex flex-wrap items-center justify-between" v-if="roleName == 'tenant'">
          <vx-input-group class="mb-base mr-3" v-if="roleName == 'admin'">
            <vs-input v-model="mailTo" placeholder="Email" />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button type="border" @click="mailTo = ''" class="whitespace-no-wrap cursor-not-allowed" :disabled="roleName == 'tenant'">Send Invoice</vs-button>
              </div>
            </template>
          </vx-input-group>
          <div class="vx-col w-full flex" id="account-manage-buttons">
            
          </div>
          <div class="flex items-center">            
            <vs-button icon-pack="feather" icon="icon-edit" class="mb-base mr-3 cursor-not-allowed" :to="{name: 'app-billing-edit', params: { editId: $route.params.viewId }}" :disabled="roleName == 'tenant'"
            v-if="roleName == 'admin'"
            >Edit</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" class="mb-base mr-3 cursor-not-allowed" @click="confirmDeleteRecord" :disabled="roleName == 'tenant'"
            v-if="roleName == 'admin'"
            >Delete</vs-button>
          </div>
          <div class="flex items-center">            
            <!-- <vs-button class="mb-base mr-3" type="border" icon-pack="feather" icon="icon icon-download">Download</vs-button> -->
            <!-- <vs-button class="mb-base mr-3" type="border" icon-pack="feather" icon="icon icon-check-square">Accept</vs-button> -->
            <vs-button icon-pack="feather" color="success" icon="icon-dollar-sign" 
            v-if="roleName == 'tenant'"
            :class="{'cursor-not-allowed': parseInt(view_data.status) == 1, 'mb-base mr-3': true}"
            :disabled="parseInt(view_data.status) == 1"
            :to="{name: 'caliber-financial-new', params: { billId: $route.params.viewId }}"
            >Pay Now</vs-button>
            
          </div>          
        </div>

        <vx-card id="invoice-container">

            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
              <div class="vx-col w-1/2 mt-12">
                    <h5>{{optionalChaning(() => view_data.property.name)}}</h5>
                    <div class="invoice__recipient-info my-4">
                        <p>{{ optionalChaning(() => view_data.property.BillingAddress1) }}</p>
                        <p>{{ optionalChaning(() => view_data.property.BillingAddress2) }}</p>
                        <p>{{ optionalChaning(() => view_data.property.BillingAddress3) }}</p>
                        <p>{{ `${optionalChaning(() => view_data.property.BillingCity)} ${optionalChaning(() => view_data.property.BillingZip)}, ${optionalChaning(() => view_data.property.country_master.name)}` }}</p>
                    </div>
                </div>
              <!--   <div class="vx-col w-1/2 mt-base">
                    <img src="@/assets/images/logo/logo-axp.png" alt="vuexy-logo">
                </div> -->
                <div class="vx-col w-1/2 text-right">
                    <h1>Invoice</h1>
                    <div class="invoice__invoice-detail mt-6">
                        <p class="mt-4"><strong>INVOICE NO.</strong></p>
                        <p>{{ view_data.invoice_no }}</p>

                        <p class="mt-4"><strong>INVOICE DATE</strong></p>
                        <p>{{ new Date(view_data.createdAt) | date(true) }}</p>

                        <p class="mt-4"><strong>DUE DATE</strong></p>
                        <p>{{ new Date(view_data.due_date) | date(true) }}</p>

                        <p class="mt-4"><strong>Account ID</strong></p>
                        <p>{{  }}</p>
                    </div>
                </div>
                
                <div class="vx-col w-1/2 mt-12">
                    <h5>Bill To</h5>
                    <div v-if="Object.keys(recipientDetails).length">
                      <div class="invoice__recipient-info my-4">
                          <p>{{ recipientDetails.full_name }}</p>
                          <p>{{ recipientDetails.address_line_1 }}</p>
                          <p>{{ recipientDetails.address_line_2 }}</p>
                          <p>{{ `${recipientDetails.province} ${recipientDetails.postcode}, ${optionalChaning(() =>recipientDetails.country_master.name)}` }}</p>
                      </div>
                      <div class="invoice__recipient-contact ">
                          <p class="flex items-center">
                              <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                              <span class="ml-2">{{ recipientDetails.email }}</span>
                          </p>
                          <p class="flex items-center">
                              <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                              <span class="ml-2">{{ recipientDetails.phone1 }}</span>
                          </p>
                      </div>
                    </div>
                    <div v-else><i>-- No user account has been assigned on this unit. --</i></div>

                </div>
            </div>

            <!-- INVOICE CONTENT -->
            <div class="p-base">
                <!-- INVOICE TASKS TABLE -->
                <vs-table>
                    <!-- HEADER -->
                    <template slot="thead">
                        <vs-th class="pointer-events-none">Bill Type</vs-th>
                        <vs-th class="pointer-events-none">UNIT</vs-th>
                        <vs-th class="pointer-events-none">DESCRIPTION</vs-th>
                        <vs-th class="pointer-events-none">AMOUNT</vs-th>
                    </template>

                    <!-- DATA -->
                    <template>
                        <!-- <vs-tr v-for="(tr, index) in data" :key="index"> -->
                        <vs-tr>
                          <vs-td>{{ optionalChaning(() => view_data.bill_type.name) }}</vs-td>
                          <vs-td>{{ optionalChaning(() => view_data.unit.number) }}</vs-td>
                          <vs-td>{{ optionalChaning(() =>view_data.description) }}</vs-td>
                          <vs-td>{{ optionalChaning(() =>view_data.amount) }} USD</vs-td>
                        </vs-tr>
                    </template>
                    <template slot="no-data"><div></div></template>
                </vs-table>

                <!-- INVOICE SUMMARY TABLE -->
                <vs-table hoverFlat class="w-1/2 ml-auto mt-4">
                   <!--  <vs-tr>
                        <vs-th class="pointer-events-none">SUBTOTAL</vs-th>
                        <vs-td>{{ view_data.amount }} USD</vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">DISCOUNT (0%)</vs-th>
                        <vs-td>0 USD</vs-td>
                    </vs-tr> -->
                    <vs-tr>
                        <vs-th class="pointer-events-none">TOTAL</vs-th>
                        <vs-td>{{ view_data.amount }} USD</vs-td>
                    </vs-tr>
                    <template slot="no-data"><div></div></template>
                </vs-table>
            </div>
            <div class="vx-row leading-loose">
            <div class="vx-col w-1/2">
              <strong>Produced by:</strong> <img src="@/assets/images/logo/logo-axp.png" alt="vuexy-logo">
            </div>

            <!-- INVOICE FOOTER -->
            <div class="vx-col w-1/2 approval-widget">
              <approval 
                :items="JSON.parse(JSON.stringify(approvals))" 
                :reference_id="view_data.id"
                :reference_no="view_data.invoice_no"
                type="bill"
                class="mb-4" />
            </div>
          </div>
        </vx-card>

       

        <vs-alert color="danger" title="Data Not Found" :active.sync="data_not_found">
          <span>Data record with id: {{ $route.params.viewId }} not found. </span>
          <span>
            <span>Check </span><router-link :to="{name:'app-billing-list'}" class="text-inherit underline">All Data</router-link>
          </span>
        </vs-alert>        
    </div>
</template>

<script>
import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud
import Approval from '../../../components/approval-widget/approval'
const jwt = require('jsonwebtoken')

export default{
  components: {
    Approval
  },
  data () {
    const token = localStorage.usertoken
    return {
      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,

      roleName: '',
      token: token,
      mailTo: '',
      view_data: {
        unit_resident_id: '',
        bill_type_id: '',
        amount: '',
        due_date: '',
        generated_date: '',
        from_date: '',
        to_date: '',
        description: '',
        payer_name: '',
        payer_email: '',
        payer_address: '',
        payer_phone: '',
        payee_name: '',
        payee_email: '',
        payee_phone: '',
        payee_address: '',
        status: '',
        bill_config_id: '',
        unit_id: '',
        property_id: '',
        id: 0,
        invoice_no: '',
      },
      approvals: [],
      recipientDetails: {},
      data_not_found: false,
    }
  },
  computed: {

  },
  methods: {
    printInvoice () {
      window.print()
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.view_data.id}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/billing/delete/${viewId}`, {
              token: this.token
            })
            .then(res => {        
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
              } else {
                this.$router.push({name:'app-billing-list'})
                this.showDeleteSuccess()
              }

            })
            .catch(err => {              
              reject(err)
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.data_local = res[0]
        })
      })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Data Deleted',
        text: 'The selected data was successfully deleted'
      })
    },
    async loadUserPem() {
      var decoded = jwt.verify(this.token, 'secret')  
      const viewId = decoded.id
      var d = await axios.get(`/user/view/${viewId}`, {
        headers: { 'Authorization': this.token }
      }) 
      const userD = d['data'][0]['user_role']['val']
      this.roleName = userD

      console.log('this.roleName ', this.roleName)
    },
    loadData () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.get(`/billing/view/${viewId}`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-billing-list'})
              } else {
                resolve(res['data'])
              }

              this.$vs.loading.close()
            })
            .catch(err => {
              this.data_not_found = true
              this.$vs.loading.close()
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.view_data = res[0]
          this.recipientDetails = res[0].unit.unit_residents[0].user;
          this.view_data.approval 
            ? this.view_data.approval.approval_items
              .sort((a, b) => a.level - b.level) 
              .map((v, i) =>this.$set(this.approvals, i, v))
            : []

            
        })
      })
    },
    optionalChaning(fn) {
      try { return fn(); }
      catch (e) {}
    }
  },
  mounted () {
    this.loadUserPem()
    this.loadData()
    this.$emit('setAppClasses', 'invoice-page')
  },
  async created () {
    // crud
    this.showL = await mainHelper.cansee('billing-list', 'list')
    this.showC = await mainHelper.cansee('billing-create', 'create')
    this.showR = await mainHelper.cansee('billing-read', 'read')
    this.showU = await mainHelper.cansee('billing-update', 'update')
    this.showD = await mainHelper.cansee('billing-delete', 'delete')

    if (!this.showR) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }
  }  
}
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    .vs-table--tbody-table .tr-values td,
    p {
      font-size: 11px;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }
    .approval-widget {
      display: none;
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
.vs-table--not-data {
  display: none;
}
</style>
